import React from 'react';
import { UsageRightStatus } from './types';
import styles from '../../../styles/usageRights.module.css';

interface UsageRightStatusTagProps {
  status: UsageRightStatus;
}

const UsageRightStatusColorMap = {
  pending: {
    color: 'var(--text-blue)',
    bg: 'var(--secondary-surface-blue)',
    text: 'New Request',
  },
  accepted: {
    color: 'var(--text-success)',
    bg: 'var(--secondary-surface-green)',
    text: 'Approved',
  },
  rejected: {
    color: 'var(--critical-r-500)',
    bg: 'var(--secondary-surface-red)',
    text: 'Rejected',
  },
  negotiation: {
    color: 'var(--text-yellow)',
    bg: 'var(--secondary-surface-yellow)',
    text: 'Negotiation',
  },
};

function UsageRightStatusTag({ status }: UsageRightStatusTagProps) {
  return (
    <div
      className={styles.usageRightStatusTagContainer}
      style={{
        color: UsageRightStatusColorMap?.[status]?.color,
        backgroundColor: UsageRightStatusColorMap?.[status]?.bg,
      }}
    >
      {UsageRightStatusColorMap?.[status]?.text}
    </div>
  );
}

export default UsageRightStatusTag;
